var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronLeftIcon, ChevronRightIcon } from '@marketing-icons';
import { clsx } from 'clsx';
var MAX_PAGES = 9;
var HALF_MAX_PAGES = Math.floor(MAX_PAGES / 2);
var Pagination = function (_a) {
    var pageCount = _a.pageCount, onPageChange = _a.onPageChange, currentPageIndex = _a.currentPageIndex, _b = _a.theme, theme = _b === void 0 ? 'dark' : _b;
    var textColorStyle = theme === 'dark' ? 'text-text-white' : 'text-text-shoe';
    var midRange = [];
    if (pageCount <= MAX_PAGES) {
        for (var i = 2; i < pageCount; i++) {
            midRange.push(i);
        }
    }
    else {
        var start = Math.max(currentPageIndex - HALF_MAX_PAGES, 2);
        var end = Math.min(currentPageIndex + HALF_MAX_PAGES, pageCount - 1);
        for (var i = start; i <= end; i++) {
            midRange.push(i);
        }
    }
    return (_jsxs("div", __assign({ className: clsx('w-full flex justify-between items-center', textColorStyle) }, { children: [_jsx("button", __assign({ "aria-label": "Go to previous page", disabled: currentPageIndex === 1, onClick: function () {
                    onPageChange(currentPageIndex - 1);
                }, className: clsx('flex w-[9px] h-[15px] justify-start items-center mr-2 shrink-0 disabled:text-icon-dark-grey', theme === 'light' ? 'text-icon-dark' : 'text-icon-white') }, { children: _jsx(ChevronLeftIcon, {}) })), _jsxs("div", __assign({ className: "flex gap-[15px]" }, { children: [_jsx("button", __assign({ className: "min-w-[12px]", onClick: function () { return onPageChange(1); } }, { children: _jsx("span", __assign({ className: clsx(currentPageIndex === 1
                                ? 'text-sm-med-m md:text-sm-med-d'
                                : 'text-sm-reg-m md:text-sm-reg-d') }, { children: 1 })) })), currentPageIndex - HALF_MAX_PAGES > 1 && _jsx("span", { children: "..." }), midRange.length > 0 &&
                        midRange.map(function (idx) { return (_jsx("button", __assign({ className: "min-w-[12px]", onClick: function () { return onPageChange(idx); } }, { children: _jsx("span", __assign({ className: clsx(currentPageIndex === idx
                                    ? 'text-sm-med-m md:text-sm-med-d'
                                    : 'text-sm-reg-m md:text-sm-reg-d') }, { children: idx })) }), idx)); }), currentPageIndex + HALF_MAX_PAGES < pageCount && _jsx("span", { children: "..." }), pageCount > 1 && (_jsx("button", __assign({ className: "min-w-[12px]", onClick: function () { return onPageChange(pageCount); } }, { children: _jsx("span", __assign({ className: clsx(currentPageIndex === pageCount
                                ? 'text-sm-med-m md:text-sm-med-d'
                                : 'text-sm-reg-m md:text-sm-reg-d') }, { children: pageCount })) })))] })), _jsx("button", __assign({ "aria-label": "Go to next page (".concat(currentPageIndex + 1, ")"), disabled: currentPageIndex === pageCount, onClick: function () {
                    onPageChange(currentPageIndex + 1);
                }, className: clsx('flex w-[9px] h-[15px] justify-end items-center ml-2 shrink-0 disabled:text-icon-dark-grey', theme === 'light' ? 'text-icon-dark' : 'text-icon-white') }, { children: _jsx(ChevronRightIcon, {}) }))] })));
};
export default Pagination;
